import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';
import { useEffect, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';

import { getUserById } from '../../../../../redux/assignees/selectors';
import {
  getOpenedTaskComments,
  getOpenedTaskCreatedAt,
  getOpenedTaskCreatedBy,
} from '../../../../../redux/tasks/taskEntities/selectors';

import ActivityViewer from '../../../atoms/ticket-drawer/ActivityViewer';

TimeAgo.addLocale(en);

const TaskDetailsActivitySection = ({
  createdAt,
  taskComments,
  taskCreator,
}) => {
  const intl = useIntl();

  const [comments, setComments] = useState(taskComments?.filter((c) => c?.type === 'activity') || []);

  const timeAgo = useMemo(() => new TimeAgo(intl.locale), [intl.locale]);

  useEffect(() => {
    setComments(taskComments?.filter((c) => c?.type === 'activity') || []);
  }, [taskComments]);

  return (
    <div className="task-details-activity-section-content-wrapper space-y-4 w-full">
      {/* Block 1 */}
      <div className="task-details-activity-list-wrapper pt-4 px-2" style={{ paddingBottom: 0 }}>
        <ul className="list-none p-0 m-0">
          {[
            {
              type: 'activity',
              action: ' created this task',
              createdAt: createdAt,
              actor: taskCreator,
              field: 'createdBy',
            },
          ].map((chat) => {
            const date = new Date(chat?.createdAt);
            const time = timeAgo.format(date);
            return <ActivityViewer key={chat?._id} chat={chat} time={time} />;
          })}
          {comments?.map((chat) => {
            const date = new Date(chat?.createdAt);
            const time = timeAgo.format(date);
            return <ActivityViewer key={chat?._id} chat={chat} time={time} />;
          })}
        </ul>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const createdBy = getOpenedTaskCreatedBy(state);

  return {
    createdAt: getOpenedTaskCreatedAt(state),
    taskComments: getOpenedTaskComments(state),
    taskCreator: getUserById(state, { userId: createdBy }),
  };
};

export default connect(mapStateToProps)(TaskDetailsActivitySection);
